import { NavLink } from 'react-router';
import { GROUP_ORDER, modulesFor } from '../config/modules';
import { useAuth } from '../auth/context';
import { useUi } from '../stores/ui';

export function Sidebar({ open, onNavigate }: { open: boolean; onNavigate: () => void }) {
  const { user } = useAuth();
  const collapsed = useUi((s) => s.sidebarCollapsed);
  const mods = modulesFor(user?.role);
  return (
    <nav className={`sidebar${open ? ' open' : ''}`} aria-label="Main">
      <div className="brand">
        <div className="brand-mark">{collapsed ? 'H&S' : 'HARNEY & SONS'}</div>
        <div className="brand-sub">Leadership Dashboards</div>
      </div>
      {GROUP_ORDER.map((g) => {
        const items = mods.filter((m) => m.group === g);
        if (!items.length) return null;
        return (
          <div key={g} role="group" aria-label={g}>
            <div className="nav-group">{g}</div>
            {items.map((m) => (
              <NavLink
                key={m.key}
                to={m.path}
                className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
                title={collapsed ? m.label : undefined}
                onClick={onNavigate}
              >
                <m.icon size={17} strokeWidth={1.8} />
                <span className="nav-label">{m.label}</span>
                {m.status === 'placeholder' && <span className="soon">Soon</span>}
              </NavLink>
            ))}
          </div>
        );
      })}
      <div className="sidebar-foot">Harney &amp; Sons Fine Teas</div>
    </nav>
  );
}
